import { render, staticRenderFns } from "./ArrowDoubleLeftIcon.vue?vue&type=template&id=c22a46e4"
import script from "./ArrowDoubleLeftIcon.vue?vue&type=script&lang=ts"
export * from "./ArrowDoubleLeftIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports